/**************************************************************************************************/
/*   File: /src/app/shared/services/authorization/authorization.service.ts                        */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed Jul 31 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { NGXLogger } from 'ngx-logger';
import { Observable, of } from 'rxjs';
import { delay, switchMap } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../environments/environment';
import * as fromModels from '../../models';
import { HeaderService } from '../utils/header.service';

/**
 * The authorization service
 */
@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  /**
  * The api url for authorization users
  */
  apiUrl = environment.serviceHost;
  /**
   * The api path
   */
  apiPath = environment.apiPath;
  /**
   * The gportal auth path
   */
  path = 'portal-auth';

  /**
    * The constructor
    * @param http The http 
    * @param logger the logger
    * @param headerService The header service
    */
  constructor(private http: HttpClient, private logger: NGXLogger, private headerService: HeaderService) {
  }

  /**
   * Get authorization status
   * @param documentId The document id
   */
  getAuthorizationStatus(): Observable<fromModels.AuthorizationStatus> {
    console.log(this.headerService.getHeaders());
    return this.http.get<fromModels.AuthorizationStatus>(
      `${this.apiUrl}${this.apiPath}${this.path}/status`,
      this.headerService.getHeaders());
  }

  /**
   * Create the request
   * @param data The data
   */
  createRequest(documentId: fromModels.LocalDocumentId): Observable<fromModels.Result> {
    return this.http.post<fromModels.Result>(
      `${this.apiUrl}${this.apiPath}${this.path}/create`,
      documentId,
      this.headerService.getHeaders());
  }

}
